import {type DiscoveryNode, type DiscoveryStrategy} from '../discovery/index.ts';
import {KubernetesConfig} from './KubernetesConfig.ts';
import {KubernetesApiEndpointResolver} from './KubernetesApiEndpointResolver.ts';
import {KubernetesEndpointResolver} from './KubernetesEndpointResolver.ts';
import {type ClusterTopologyIntentTracker} from '../instance/ClusterTopologyIntentTracker.ts';
import {type Logger} from '../logging.ts';

export class KubernetesDiscoveryStrategy implements DiscoveryStrategy {
    private readonly logger: Logger;
    private readonly endpointResolver: KubernetesEndpointResolver;

    constructor(logger: Logger, properties: {[key: string]: string | number | boolean}, intentTracker?: ClusterTopologyIntentTracker) {
        this.logger = logger;
        const config = new KubernetesConfig(properties);
        this.logger.info(`${config}`);
        this.endpointResolver = KubernetesApiEndpointResolver.of(this.logger, config, intentTracker);
        this.logger.info(`Kubernetes Discovery activated with mode: ${config.mode}`);
    }
    async start() {
        await this.endpointResolver.start();
    }

    async discover(): Promise<Iterable<DiscoveryNode> | undefined> {
        return undefined
    }

    async close() {
        await this.endpointResolver.close();
    }
}
